module.exports = __webpack_public_path__ + "media/icons/non-confidential-743bd95b.svg";